export function formatNumberToNumericalAbreviation(num: number): string {
  if (Math.abs(num) < 1000) {
    return num.toString()
  }

  if (Math.abs(num) >= 1000 && Math.abs(num) < 1_000_000) {
    // Floor to 1 decimal so the displayed value never exceeds `num` in magnitude.
    // Critical for coin costs: rounding up made the UI claim 19K for an 18,999 charge.
    const value = (Math.sign(num) * Math.floor(Math.abs(num) / 100)) / 10
    return value.toFixed(1).replace(/\.0$/, '') + 'K'
  }

  if (Math.abs(num) >= 1_000_000) {
    const value = (Math.sign(num) * Math.floor(Math.abs(num) / 100_000)) / 10
    return value.toFixed(1).replace(/\.0$/, '') + 'M'
  }

  return num.toString()
}
